import { SectionTitle, SWRDataTable } from "@bleu.builders/ui";
import { withPermission } from "@components/WithAccessControl";
import { useUser } from "@contexts/UserContext";
import { hasPermission } from "@lib/permissions";
import React from "react";
import { useParams } from "react-router-dom";

function ReceiptsPage() {
  const { program_id } = useParams();
  const { permissions } = useUser();
  const hasDetails = hasPermission(permissions, "receipts", "manage");

  return (
    <div className="mx-20 mb-10">
      <div className="flex items-center justify-between space-y-2">
        <div>
          <SectionTitle>Receipts</SectionTitle>
          <p className="text-muted-foreground">
            Here is a list of all uploaded receipts
          </p>
        </div>
      </div>
      <SWRDataTable
        fetchPath={`/admin/v2/programs/${program_id}/receipts`}
        action={null}
        hasDetails={hasDetails}
      />
    </div>
  );
}

export default withPermission(ReceiptsPage, "receipts", "view");
